import { ServiceRequest } from "src/utils/service-request"
import { PRICE_BONDS_CLIENT, PRICE_BONDS_ISIN, PRICE_BONDS_DETAIL, PRICE_BONDS_UNLINK } from "src/utils/api-routes"

export default class BondsService {
  constructor() {
    this.serviceRequest = new ServiceRequest()
  }

   buildUrl(base, params = {}) {
    const query = new URLSearchParams(params).toString()
    return query ? `${base}?${query}` : base
  }

// GET 
  async getBonds(idCliente) {
    const params = idCliente ? `?IDCliente=${idCliente}` : ""
    return this.serviceRequest.get(`/cadastro/api/v1/bonds-clientes/precos/${params}`)
}

  // POST = ISIN x cliente
  registerNewIsins(data) {
    return this.serviceRequest.post(PRICE_BONDS_CLIENT, data)
  }

  // GET clientes + ISIN
  getClientsFromIsin(isin) {
    return this.serviceRequest.get(
      this.buildUrl(PRICE_BONDS_ISIN, { ISIN: isin, limit: 10000 })
    )
  }

  // DELETE por PK
  deleteIsin(pk) {
    return this.serviceRequest.delete(`${PRICE_BONDS_DETAIL}/${pk}`)
  }

  // DELETE por ISIN + IDCliente
  unlinkByIsinAndClient(isin, idCliente) {
    return this.serviceRequest.delete(
      this.buildUrl(PRICE_BONDS_UNLINK, { ISIN: isin, IDCliente_id: idCliente })
    )
  }
}